import { Head } from '@inertiajs/react';
import { Breadcrumbs, Rule, Section } from '../Components';
import { Banner, BannerHeader } from '../Components/Banners';
import { Submission as SubmissionType } from '../Types';

type SubmissionProps = {
    submission?: SubmissionType | null;
    fields: {
        id: number;
        label: string;
        type: string;
        value: any;
        is_arrayable: boolean;
        is_numerable: boolean;
    }[];
    previous?: string;
};

const Submission = ({ submission = null, fields = [] }: SubmissionProps) => {
    const title = submission
        ? `Form Submission #${submission.id}`
        : 'Form Submission Not Found';
    const { form, guid, created_at } = submission ?? {};
    const date = created_at ? new Date(created_at * 1000) : null;
    return (
        <>
            <Head>
                <title>Form Submission</title>
                <meta name='description' content='Some Content' />
            </Head>

            <Banner className='py-38 pb-26'>
                <BannerHeader>{title}</BannerHeader>
                <Rule className='mx-auto w-1/2 max-w-60' />
            </Banner>

            <Section className='pt-6 pb-10' id='submissions'>
                <div className='flex justify-between pb-10 full'>
                    <Breadcrumbs />
                </div>

                {!submission && (
                    <p className='font-light text-gray-600 text-center'>
                        Unfortunately no Form Submission could be found for that
                        Submission Identifier, the link may have been malformed,
                        or the Submission removed. Please return to the
                        Submissions page and check that the Identifier and
                        provided link is correct.
                    </p>
                )}

                {submission && (
                    <table className='w-full text-sm border-collapse table-auto'>
                        <thead>
                            <tr>
                                <th className='p-4 pt-0 pb-3 pl-8 border-gray-400 dark:border-gray-600 border-b font-bold text-gray-800 dark:text-gray-200 text-left'>
                                    Form
                                </th>
                                <th className='p-4 pt-0 pb-3 pl-8 border-gray-400 dark:border-gray-600 border-b font-bold text-gray-800 dark:text-gray-200 text-left'>
                                    GUID
                                </th>
                                <th className='p-4 pt-0 pb-3 pl-8 border-gray-400 dark:border-gray-600 border-b font-bold text-gray-800 dark:text-gray-200 text-left'>
                                    Submitted
                                </th>
                            </tr>
                        </thead>
                        <tbody className='dark:bg-zinc-800'>
                            <tr className='text-gray-500 dark:text-gray-400'>
                                <td className='p-4 pl-8 capitalize'>{form}</td>
                                <td className='p-4 pl-8'>{guid}</td>
                                <td className='p-4 pr-0 pl-8'>
                                    {date?.toLocaleTimeString()}{' '}
                                    {date?.toLocaleDateString()}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3}>
                                    <table className='w-full text-sm border-collapse table-auto'>
                                        <thead>
                                            <tr>
                                                <th
                                                    className={
                                                        'w-1/5 border-b border-gray-400 dark:text-gray-200  p-4 pt-6 pb-3 pl-8 text-left font-bold text-gray-800 shrink-0'
                                                    }
                                                >
                                                    Field
                                                </th>
                                                <th
                                                    className={
                                                        'w-1/5 border-b border-gray-400 dark:text-gray-200  p-4 pt-6 pb-3 pl-8 text-left font-bold text-gray-800 shrink-0'
                                                    }
                                                >
                                                    Type
                                                </th>
                                                <th
                                                    className={
                                                        'w-3/5 border-b border-gray-400 dark:text-gray-200  p-4 pt-6 pb-3 pl-8 text-left font-bold text-gray-800 pr-0 grow'
                                                    }
                                                >
                                                    Value
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fields.map(
                                                (
                                                    {
                                                        label,
                                                        type,
                                                        value,
                                                        is_arrayable,
                                                        is_numerable,
                                                    },
                                                    index,
                                                ) => {
                                                    return (
                                                        <tr
                                                            key={label || index}
                                                            className='text-gray-500 dark:text-gray-400'
                                                        >
                                                            <td className='p-4 pl-8 border-gray-100 dark:border-gray-700 border-b capitalize'>
                                                                {label}
                                                            </td>
                                                            <td className='p-4 pl-8 border-gray-100 dark:border-gray-700 border-b capitalize'>
                                                                {type}
                                                            </td>
                                                            <td className='p-4 pr-0 pl-8 border-gray-100 dark:border-gray-700 border-b'>
                                                                {is_arrayable &&
                                                                Array.isArray(
                                                                    value,
                                                                )
                                                                    ? value
                                                                          .map(
                                                                              (
                                                                                  part,
                                                                              ) =>
                                                                                  `"${part}"`,
                                                                          )
                                                                          .join(
                                                                              ', ',
                                                                          )
                                                                    : is_numerable &&
                                                                        !isNaN(
                                                                            value,
                                                                        )
                                                                      ? value
                                                                      : `"${value}"`}
                                                            </td>
                                                        </tr>
                                                    );
                                                },
                                            )}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </Section>
        </>
    );
};

export default Submission;
